import { render } from "./DocumentBuilderPage.vue?vue&type=template&id=1a9ab35f"
import script from "./DocumentBuilderPage.vue?vue&type=script&lang=js"
export * from "./DocumentBuilderPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__